import { useEffect, useState } from 'react'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { columns } from 'features/tasks/components/columns'
import { DataTable } from 'features/tasks/components/data-table'
import { TasksDialogs } from 'features/tasks/components/tasks-dialogs'
import { TasksPrimaryButtons } from 'features/tasks/components/tasks-primary-buttons'
import TasksProvider from 'features/tasks/context/tasks-context'
import { Loader } from 'lucide-react'
import { useAppDispatch, useAppSelector } from 'store/store'
import {
  fetchUpdateTasks,
  saveUpdateTask,
} from 'store/updateTasks/updateTaskSlice'
import DropZone from 'ui/components/DropZone'

const UpdateTasksPage = () => {
  const dispatch = useAppDispatch()
  const updateTaskState = useAppSelector((state) => state.update_tasks)
  const [pageIndex, setPageIndex] = useState(0) // React Table uses 0-based index
  const pageSize = 20

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchUpdateTasks(pageIndex + 1)) // Your API likely uses 1-based index
    }

    fetchData()
  }, [dispatch, pageIndex])

  const { loading, error, update_tasks, totalPages } = updateTaskState

  const onFileDrop = (event: Event) => {
    // È buona pratica prevenire il comportamento di default del browser nel drag&drop
    event.preventDefault()

    const reader = new FileReader()
    const dragEvent = event as DragEvent
    const filename = dragEvent?.dataTransfer?.files?.[0]?.name

    reader.addEventListener('load', async () => {
      // <--- Aggiunto 'async'
      try {
        // Aspettiamo che il dispatch (e quindi l'API) abbia finito usando .unwrap()
        await dispatch(
          saveUpdateTask({
            file: reader.result as string, // Data URL (readAsDataURL)
            filename,
            run_after_save: false,
          })
        ).unwrap()

        // OPZIONE 1 (Consigliata): Ricarica solo i dati invece dell'intera pagina
        dispatch(fetchUpdateTasks(pageIndex + 1))

        // OPZIONE 2: Se devi assolutamente ricaricare la pagina intera, fallo solo ora
        // window.location.reload();
      } catch (error) {
        console.error('Errore durante il caricamento del file:', error)
      }
    })

    if (dragEvent.dataTransfer && dragEvent.dataTransfer.files.length > 0) {
      reader.readAsDataURL(dragEvent.dataTransfer.files[0])
    }
  }

  return (
    <TasksProvider>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}

      {loading ? (
        <Loader className='h-5 w-5 animate-spin' />
      ) : error ? (
        <>Errore nel fetch dei dati</>
      ) : (
        <Main>
          <DropZone onFileDrop={onFileDrop}>
            <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
              <div>
                <h2 className='text-2xl font-bold tracking-tight'>Tasks</h2>
                <p className='text-muted-foreground'>Aggiornamenti del DB</p>
              </div>
              <TasksPrimaryButtons />
            </div>
            <div className='-mx-4 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
              {update_tasks && (
                <DataTable
                  columns={columns}
                  data={update_tasks || []}
                  pageCount={totalPages}
                  pageIndex={pageIndex}
                  pageSize={pageSize}
                  onPageIndexChange={setPageIndex}
                />
              )}
            </div>
          </DropZone>
        </Main>
      )}

      <TasksDialogs />
    </TasksProvider>
  )
}

export default UpdateTasksPage
